<template>
  <!-- 帮助视频默认展示；离开帮助视频或关闭时卸载播放器，避免后台继续播放。 -->
  <a-modal :visible="visible" :title="title + ' · 帮助'" :footer="null" :width="860" :destroyOnClose="true" @cancel="$emit('close')">
    <a-tabs v-if="visible" v-model:activeKey="activeTab">
      <a-tab-pane key="video" tab="帮助视频">
        <div v-if="activeTab === 'video' && safeUrl" class="function-help-video">
          <video :key="safeUrl" :src="safeUrl" controls playsinline preload="metadata" @error="failed = true" @loadeddata="failed = false"></video>
          <p v-if="failed" role="alert">视频暂时无法播放，请检查网络或联系管理员核对视频地址。</p>
        </div>
        <a-empty v-else-if="activeTab === 'video'" description="暂无帮助视频，请查看使用说明。" />
      </a-tab-pane>
      <a-tab-pane key="text" tab="使用说明">
        <section class="function-help-text" aria-label="使用说明">
          <h3>适合做什么？</h3>
          <p>{{ description || '查看本页信息，处理当前账号可使用的管理功能。' }}</p>
          <h3>使用方法</h3>
          <div v-for="(section, index) in usageSteps" :key="section.title" class="function-help-step">
            <span aria-hidden="true">{{ index + 1 }}</span>
            <div><h4>{{ section.title }}</h4><p v-if="section.steps?.length === 1">{{ section.steps?.[0] }}</p><ol v-else><li v-for="step in section.steps" :key="step">{{ step }}</li></ol></div>
          </div>
          <template v-for="section in usageNotes" :key="section.title">
            <h3>{{ section.title }}</h3><p>{{ section.content }}</p>
          </template>
          <p class="function-help-note">请以当前页面实际显示的按钮、账号权限和处理结果为准。提交或保存后，查看页面反馈，并在对应列表、明细或设置中重新核对结果。</p>
        </section>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script lang="ts">
// 使用说明以文本渲染，视频沿用已有安全地址校验。
import { computed, defineComponent, ref, watch } from 'vue'
import { safeFunctionVideoUrl } from '@/utils/functionGuides'
import { resolveAdminFunctionUsage } from '@/utils/adminFunctionUsage'
export default defineComponent({
  props: {
    visible: Boolean, url: { type: String, default: '' }, title: { type: String, default: '' },
    description: { type: String, default: '' }, path: { type: String, default: '' }
  },
  emits: ['close'],
  setup(props) {
    const activeTab = ref('video'), failed = ref(false)
    const safeUrl = computed(() => safeFunctionVideoUrl(props.url))
    const usageSections = computed(() => resolveAdminFunctionUsage(props.path))
    const usageSteps = computed(() => usageSections.value.filter(section => section.steps?.length))
    const usageNotes = computed(() => usageSections.value.filter(section => section.content))
    watch(() => props.visible, () => { activeTab.value = 'video'; failed.value = false }, { flush: 'sync' })
    watch(() => [props.url, activeTab.value], () => { failed.value = false }, { flush: 'sync' })
    return { activeTab, failed, safeUrl, usageSteps, usageNotes }
  }
})
</script>
<style scoped>
/* 和报表设计说明共用用途、编号步骤、注意事项的阅读层次。 */
.function-help-text { min-height:180px; max-height:60vh; overflow:auto; padding:8px 12px 20px; color:#6d829a; line-height:1.9; }
.function-help-text h3 { margin:22px 0 9px; color:#244568; font-size:16px; }
.function-help-text h3:first-of-type { margin-top:0; }
.function-help-step { display:flex; gap:15px; margin:24px 0; }
.function-help-step>span { flex:none; width:32px; height:32px; border-radius:9px; background:#e9f4ff; color:#1890ff; font-weight:600; line-height:32px; text-align:center; }
.function-help-step>div { min-width:0; }
.function-help-step h4 { margin:0 0 6px; color:#325375; font-size:14px; font-weight:600; }
.function-help-step p { font-size:13px; }
.function-help-text p,.function-help-text li { white-space:pre-wrap; overflow-wrap:anywhere; line-height:1.8; }
.function-help-text p { margin:0; }
.function-help-text ol { margin:0; padding-left:19px; list-style:decimal; font-size:13px; }
.function-help-text li + li { margin-top:6px; }
.function-help-text .function-help-note { margin-top:24px; padding:15px; border-radius:7px; background:#f1f7fc; font-size:12px; }
.function-help-video video { display:block; width:100%; max-height:60vh; background:#000; }
.function-help-video p { color:#cf1322; margin:12px 0 0; }
</style>
